import React from 'react';
import { useTransition } from 'transition-hook';

import { Box } from '@/components/shared/layout/box';
import { styled } from '@/stitches.config';

const StyledDealerPanelDrawer = styled('div', {
  position: 'fixed',
  left: 0,
  top: 0,
  width: '100%',
  height: 'max(var(--viewport-height), 100%)',
  zIndex: '$panel',
  transform: 'translateY(100%)',
  transitionProperty: 'transform',
  transitionDuration: '0.65s',
  transitionTimingFunction: 'cubic-bezier(0.25,0.74,0.22,0.99)',
  willChange: 'transform',
  '@lg': {
    maxWidth: '512px',
  },
});

interface DealerPanelDrawerProps {
  isOpen: boolean;
  children?: React.ReactNode;
}

export const DealerPanelDrawer: React.FunctionComponent<
  DealerPanelDrawerProps
> = (props: DealerPanelDrawerProps) => {
  const DRAWER_TRANS = useTransition(props.isOpen, 600);

  return (
    DRAWER_TRANS.shouldMount && (
      <StyledDealerPanelDrawer
        css={{
          pe: DRAWER_TRANS.stage === 'enter' ? 'all' : 'none',
          transform:
            DRAWER_TRANS.stage === 'enter'
              ? 'translateY(0)'
              : 'translateY(100%)',
          '@lg': {
            transform:
              DRAWER_TRANS.stage === 'enter'
                ? 'translateX(0)'
                : 'translateX(-100%)',
          },
        }}
        data-test="dealer_panel_drawer"
      >
        <Box position="absolute" width="full" height="full">
          {props.children}
        </Box>
      </StyledDealerPanelDrawer>
    )
  );
};

DealerPanelDrawer.displayName = 'SectionDealerPanelDrawer';
